import Member from "../Member/Member";

/**
 * MembersPage - Settings page content for Members management
 * Renders inside SettingsLayout via Outlet
 */
const MembersPage = () => {
  return <Member />;
};

export default MembersPage;
